import { useEffect, useState } from "react";
import StaffChatMessage from "./Components/StaffChatMessage";
import "./StaffChat.css";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager.js";
import { GetCurrentUser } from "../../../../../../../Services/Authorization/AuthorizationManager.js";

const StaffChat = ({serverId}) => {
    const serverRequests =  new ServerRequests();

    const [staffChatMessages, setStaffChatMessages] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        serverRequests.GetStaffChat(serverId, setStaffChatMessages);

        setInterval(() => {
            serverRequests.GetStaffChat(serverId, setStaffChatMessages);
        }, 5000)
    }, [serverId]);

    const sendMessage = (prefix) => {
        
        if(message.length > 0) {
            const command = `${prefix}[${new Date().toTimeString().split(' ')[[0]]}] ${GetCurrentUser().Login} (StaffPanel) ${message}`;

            serverRequests.ExecuteCommand(serverId, command, () => {
                AddToastNotification("Wiadomość wysłana!", 1)
                setMessage("");
            }) 
        }
        else{
            AddToastNotification("Wiadomość nie może być pusta!", 0)
        }
    }

    return (
        <>
            <h3 className="text-center">Write a message in the textbox and then select appropriate action.</h3>     
            <div className="adminChatContainer">
                { staffChatMessages.map(message => 
                    <StaffChatMessage message={message}/>
                )}
                { staffChatMessages.length == 0 &&
                    <h3 className="text-center mt-4">Nie ma nowych wiadomości!</h3>
                }
            </div>   
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Write a message to other staff members" className="raTextArea mx-[2%] w-[96%] mt-4" rows={2}/>
            <div className="flex gap-2 mx-[2%] mt-8">
                <div className="remoteAdminButton flex-1" onClick={() => setMessage("")}>CLEAR INPUT</div>
                <div className="remoteAdminButton flex-1" onClick={() => sendMessage("@@@")}>SEND SILENTLY</div>
                <div className="remoteAdminButton flex-1" onClick={() => sendMessage("@")}>SEND WITH BROADCAST</div>
            </div>
        </>
    )
}
export default StaffChat;